import uniq from 'lodash/uniq';
import React from 'react';
import { Badge } from 'reactstrap';

import AttachmentsModal from '../../attachments/AttachmentsModal';
import { OPPORTUNITY } from '../../attachments/constants';
import { BUSINESS_TYPES } from '../../constants';
import AddCampaignButton from '../../opportunities/AddCampaignButton';
import RecreateCampaignButton from '../../opportunities/RecreateCampaignButton';
import ProjectOpportunityFormWrapper from '../ProjectOpportunity/ProjectOpportunityFormWrapper';
import ProjectHeaderForm from './ProjectHeaderForm';

const renderProjectHeaderContent = (model, onChange, isEditing) => (
  <ProjectHeaderForm
    opportunity={model}
    onChange={onChange}
    isEditing={isEditing}
  />
);

const renderProjectHeaderTitle = ({
  model,
  addCampaignIdToModel,
  isEditing,
  campaignLinesById,
}) => {
  const campaignLines = campaignLinesById
    ? Object.values(campaignLinesById)
    : [];
  const campaignBusinessTypes = uniq(
    campaignLines.map(campLine => {
      const businessType = BUSINESS_TYPES.find(business => {
        if (campLine.product.business.includes(business)) return business;
        return null;
      });
      return businessType;
    }),
  );
  return (
    <div className="d-flex justify-content-between w-100">
      <h4 className="mb-0">{model.name}</h4>
      <div className="d-flex">
        {campaignBusinessTypes.map((item, index) => (
          <div
            key={index} // eslint-disable-line react/no-array-index-key
            className="mr-2"
          >
            <h4>
              <Badge className="p-2 pr-3 pl-3" pill color="success">
                {item}
              </Badge>
            </h4>
          </div>
        ))}
        {isEditing ? (
          <div className="mr-2">
            {model.campaignId ? (
              <RecreateCampaignButton campaignId={model.campaignId} />
            ) : (
              <AddCampaignButton
                opportunityId={model.id}
                onSuccess={campaign => addCampaignIdToModel(campaign)}
              />
            )}
          </div>
        ) : null}
        <div>
          <AttachmentsModal objectId={model.id} contentType={OPPORTUNITY} />
        </div>
      </div>
    </div>
  );
};

export default function ProjectHeader(props) {
  return (
    <ProjectOpportunityFormWrapper
      {...props}
      isExpandable={false}
      renderTitle={renderProjectHeaderTitle}
      renderContent={renderProjectHeaderContent}
    />
  );
}
